import { render, staticRenderFns } from "./CurrentStep.vue?vue&type=template&id=5a28372c&scoped=true&"
import script from "./CurrentStep.vue?vue&type=script&lang=js&"
export * from "./CurrentStep.vue?vue&type=script&lang=js&"
import style0 from "./CurrentStep.vue?vue&type=style&index=0&id=5a28372c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a28372c",
  null
  
)

export default component.exports